// extracted by mini-css-extract-plugin
export default {"wrap":"Fo-z","logoContainer":"Go-z","brandImg":"Ho-z","logoImg":"Io-z","logoButton":"Jo-z"};